import { api } from '../config/api';

export const analyticsService = {

    async getBusinessHits(businessId: string, dateRange: { start: string, end: string }): Promise<any> {
        try {
            const response = await api.get(`/business-hits?business_id=${businessId}&start_date=${dateRange.start}&end_date=${dateRange.end}`);
            return response.data;
        } catch (error) {
            console.error('Error fetching business hits:', error);
        }
    },
}; 